export const STITCH_MODES = [
  { value: "existing", label: "Stitch into an existing batch" },
  { value: "new", label: "Create a new stitch batch" },
];
